import { atomFamily } from 'recoil'

import type { AsyncSelectState } from './model'

export const asyncSelectState = atomFamily<AsyncSelectState, string>({
  key: 'useAsyncSelect_state',
  default: {
    status: 'initial',
    loading: false,
    searching: false,
    initialOptions: [],
    initialOptionsCount: 0,
    searchOptions: [],
    searchOptionsCount: 0,
  },
})
